import { HeadsetIcon } from './HeadsetIcon';

/**
 * author: Google
 * id AFF98802-E02B-4EC8-8AFF-F0F5373D86C5
 * name headset
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/headset.svg
 * tags
 * - Audio 
 * - Device / Tech 
 */
export const HeadsetMicIcon = HeadsetIcon;
export default HeadsetMicIcon